import React, { useState, useEffect } from "react";
import Sidebar from './Sidebar';
import Topbar from './Topbar';

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth > 768);
  const [isNarrow, setIsNarrow] = useState(() => window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      const narrow = window.innerWidth <= 768;
      setIsNarrow(narrow);
      if (narrow) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="layout">
      <Sidebar
        collapsed={!sidebarOpen}
        isDrawerOpen={isNarrow && sidebarOpen}
        isNarrow={isNarrow}
        onClose={() => setSidebarOpen(false)}
        onToggle={() => setSidebarOpen((p) => !p)}
      />
      <main className="content">
        <Topbar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          isNarrow={isNarrow}
        />
        {children}
      </main>
    </div>
  );
}